import { DatePipe } from '@angular/common';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { HostListener } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';

import { ToastrService } from 'ngx-toastr';
import { AddaccountComponent } from 'src/app/components/account/addaccount/addaccount.component';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { AddpartyComponent } from 'src/app/components/party/addparty/addparty.component';
import { ComponentCanDeactivate } from 'src/app/components/PendingChangesGuard';
import { AddproductComponent } from 'src/app/components/product/addproduct/addproduct.component';
import { AddrawmaterialComponent } from 'src/app/components/rawmaterial/addrawmaterial/addrawmaterial.component';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
@Component({
  selector: 'app-addjournalvoucher',
  templateUrl: './addjournalvoucher.component.html',
  styleUrls: ['./addjournalvoucher.component.css']
})
export class AddjournalvoucherComponent implements OnInit, ComponentCanDeactivate {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  ischeck: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  rtnform: string = "";

  //Edit Get Values
  jvmainColl: any = [];

  jvBO: any = {}

  jvdetailscoll: any = [];

  ismanualclose: boolean;

  isaccountaddmode: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  debittotal: number = 0;
  credittotal: number = 0;
  variation: number = 0;


  branchColl: any = [];

  accountColl: any;
  costcenterColl: any = [];
  subledgerColl: any = [];
  partyallColl: any = [];
  partyColl: any = [];
  ptypeColl: any = [];



  isLoadingResult: boolean;

  jvform = new FormGroup({
    jvid: new FormControl(0),
    jvno: new FormControl(''),
    jvdate: new FormControl(null, Validators.required),
    grandtotal: new FormControl(null),
    descr: new FormControl(''),
    refno: new FormControl(null),
    isreverse: new FormControl(false),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "JournalVoucher";

  gridfocusrow: number = -1;

  errtxt: any = "";

  @Input() jvid: number = 0

  
  @Input() filterfromdate: any = null;
  @Input() filtertodate: any = null;
  @Input() formmode: String = "";
  @Output() emitData = new EventEmitter();





  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, private loginService: LoginDataService, private datePipe: DatePipe) {

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.jvform.reset();
      this.fnInitializeForm();

      if (this.jvid > 0) {
        this.fngetjv();
      }
      else {
        this.fnSetFirstRowItem()
      }

      this.fngetParty()
      this.fnGetAccount()
      this.fnGetPartyType()
      this.fngetCostCenter()
      this.fnGetParty()

      this.fnSetInitialise()



    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    // this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }

  fnSetInitialise() {

   // this.jvform.controls["partyid"].setValue(Number(this.filterpartyid));
  }
  function(e) {
    if (e.keyCode == 27) return false;
  };

  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.jvid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.isaccountaddmode = this.loginService.fnCheckUserRoleAction("Account", 'CREATE')
    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeForm() {
    this.jvform.setValue({
      jvid: 0,
      jvno: 'NEW',
      jvdate: new Date(),
      grandtotal: null,
      descr: null,
      refno: null,
      isreverse: false,
      inactive: false,
    })
  }

  fngetParty() {
    var data = {
      'partyid': 0,
      'ptype': '',
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getParty(data)
      .subscribe(
        (res) => {
          this.partyColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnGetPartyType() {
    this.ptypeColl = []
    this.ptypeColl.push({ displayname: 'Ledger', value: 'Account' })
    this.ptypeColl.push({ displayname: 'Supplier', value: 'Supplier' })
    this.ptypeColl.push({ displayname: 'Customer', value: 'Customer' })
  }

  fngetSubledger(abo) {
    var data = {
      'accountid': abo.accountid,
      'subledgerid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getSubledger(data)
      .subscribe(
        (res) => {
          var result = res.json().result;

          this.subledgerColl = result;
          console.log(this.subledgerColl)
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetCostCenter() {
    var data = {
      'costcenterid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId()
    }
    this.appService.getCostCenter(data)
      .subscribe(
        (res) => {
          var result = res.json().result;

          this.costcenterColl = result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetjv() {
    var data = {
      'jvid': this.jvid,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getJvByJvid(data)
      .subscribe(
        (res) => {

          var result = res.json().result;


          console.log(result)

          this.jvmainColl = result[0];

          var editdata = this.jvmainColl[0];
          this.jvBO = editdata;
          this.fnEditMode(editdata);

          this.jvdetailscoll = result[1];

          if (this.jvdetailscoll.length === 0) {
            this.fnSetFirstRowItem()
          }
          this.fnCalcsTotal();
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;

    for (let row of this.jvdetailscoll) {
      if (row.accountid > 0) {
        _detailscheck = true;
      }
    }


    for (let row of this.jvdetailscoll) {
      if (row.partyid > 0) {
        _detailscheck = true;
      }
    }


    if (!_detailscheck) {
      this.errtxt = "Journal Voucher Details cannot be empty"
      this.jvform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }

    if (!_ischeck) {
      console.log(Math.floor(Number(this.debittotal)))
      console.log(Math.floor(Number(this.credittotal)))
      console.log(Math.floor(this.variation))
      if (Math.floor(this.variation) !== 0) {
        this.errtxt = "Amount is mismatch"
        this.jvform.controls['inactive'].setErrors({ 'notfound': true });
        _ischeck = true;
      }
    }

    if (!_ischeck) {
      for (let row of this.jvdetailscoll) {
        if (row.accountid > 0 && this.loginService.fnCheckZeroDetcimal(row.cramt) === 0 && this.loginService.fnCheckZeroDetcimal(row.dramt === 0)) {
          this.errtxt = "Amount is cannot be empty"
          this.jvform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }
      }
    }


    if (!_ischeck) {
      for (let row of this.jvdetailscoll) {
        if (row.ptype !== '' && Number(row.accountid) === 0 && Number(row.partyid) === 0 && (this.loginService.fnCheckZeroDetcimal(row.cramt) > 0 || this.loginService.fnCheckZeroDetcimal(row.dramt > 0))) {
          this.errtxt = "Account or Party is cannot be empty"
          this.jvform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }
      }
    }

    return _ischeck;


  }
  fnResetValidation() {

    if (this.jvform.get('inactive')) {
      this.jvform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate
      if (this.jvform.valid) {

        if (this.fnValidation()) {
          return false
        }
        this.saveloading = true;
        //Check
        var data = {
          'jvid': this.jvid,
          'jvno': this.jvform.get('jvno').value,
          'jvdate': this.fnFormatDatetime(this.jvform.get('jvdate').value),
          'grandtotal': this.credittotal,
          'descr': this.jvform.get('descr').value,
          'refno': this.jvform.get('refno').value,
          'isreverse': this.jvform.get('isreverse').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.jvform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'jvdetailscoll': this.jvdetailscoll,
        }

        if (this.jvform.get('jvid').value > 0) {

          this.fnSetJv(data);
        }
        else {

          this.fnInsertJv(data);
        }

      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertJv(data) {

    this.appService.fnInsertJv(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status == 200) {
          //////this.toastr.success('', "The new Jv has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.jvno);

          var _result = res.json().result;
          if (_result.length > 0) {
            this.fnEditFormEdit(_result[0].jvid);
          }

        } else {

          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetJv(data) {

    this.appService.fnSetJv(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status == 200) {
          ////this.toastr.success('', "The Jv has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.jvid, data.jvno);

          this.fnEditFormEdit(this.jvid);
        } else {

          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    deptBO.jvdate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.jvdate));

    this.jvform.setValue({

      jvid: deptBO.jvid,
      jvno: deptBO.jvno,
      jvdate: deptBO.jvdate,
      grandtotal: deptBO.grandtotal,
      descr: deptBO.descr,
      refno: deptBO.refno,
      isreverse: deptBO.isreverse,
      inactive: deptBO.inactive,

    });


    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = false;

    if (this.formmode === 'EDIT') {
      this.iseditmode = true;
    }
    else {
      this.isviewmode = true;
    }
  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }



  fnEditFormEdit(id) {

    this.jvid = id;
    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;


    //this.ngOnInit();

    this.ismanualclose = true;
    this.fnCloseForm();

  }

  //Close
  async fnCloseForm() {

    try {

      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;


      this.emitData.emit("");
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  @HostListener('window:beforeunload')
  canDeactivate(): any {

    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }
  fnSaveAsBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
    try {
      this.jvid = 0;
      this.jvform.patchValue({
        jvid: 0,
        jvno: 'NEW',
        grandtotal: null,
        isreverse: false,
        inactive: false,
      })

      // this.fnInitializeForm();
      this.fnSetInitialise()
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }



  }

  fnChangeReverse() {

    this.iseditmode = true;

    this.isviewmode = false;
    try {
      this.jvid = 0;
      this.jvform.patchValue({
        jvid: 0,
        jvno: 'NEW',
        grandtotal: null,
        isreverse: false,
        inactive: false,
      })

      // this.fnInitializeForm();
      this.fnSetInitialise()

      for (let row of this.jvdetailscoll) {
        var dbamount = row.dramt;
        var cramount = row.cramt;
        row.dramt = cramount;
        row.cramt = dbamount
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }



  }

  sortbyKey(obj, key) {
    return obj.sort(function (a, b) {
      var keyA = a[key],
        keyB = b[key];
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

  }


  //Details

  fnSetFirstRowItem() {
    if (this.jvdetailscoll.length > 0) {
      if (!this.jvdetailscoll[this.jvdetailscoll.length - 1].accountid && !this.jvdetailscoll[this.jvdetailscoll.length - 1].partyid) {
        return
      }
    }

    var data = {
      jvdetailsid: null,
      jvid: null,
      ptype: 'Account',
      accountid: null,
      accountname: '',
      dramt: 0,
      cramt: 0,
      refno: 0,
      costcenterid: null,
      subledgerid: null,
      partyid: null,
      partyname: '',

    }

    this.jvdetailscoll.push(data)

  }

  fnChangeCredit() {

    for (let row of this.jvdetailscoll) {
      if (row.cramt > 0) {
        row.dramt = 0;
      }
    }

    this.fnCalcsTotal()
  }




  fnChangeDebit() {

    for (let row of this.jvdetailscoll) {
      if (row.dramt > 0) {
        row.cramt = 0;
      }
    }

    this.fnCalcsTotal()
  }



  fnChangeCostCenter(index) {

    var _costcentername = "";



    for (let abo of this.costcenterColl) {
      if (this.jvdetailscoll[index].costcenterid === abo.costcenterid) {
        _costcentername = abo.costcentername;
      }
    }
    this.jvdetailscoll[index].costcentername = _costcentername;


    this.fnCalcsTotal()

  }



  fnChangeSubLedger(index) {

    var _subledgername = "";



    for (let abo of this.subledgerColl) {
      if (this.jvdetailscoll[index].subledgerid === abo.subledgerid) {
        _subledgername = abo.subledgername;
      }
    }
    this.jvdetailscoll[index].subledgername = _subledgername;


    this.fnCalcsTotal()

  }


  fnCalcsTotal() {
    this.debittotal = 0;
    this.credittotal = 0;
    for (let row of this.jvdetailscoll) {
      this.debittotal = Number(this.fnConvertDecimal(this.debittotal)) + Number(row.dramt)
      this.credittotal = Number(this.fnConvertDecimal(this.credittotal)) + Number(row.cramt)
    }


    this.variation = Number(this.debittotal) - Number(this.credittotal)

    this.jvform.patchValue({ grandtotal: Number(this.debittotal) })
  }


  fnDeleteJournalVoucherConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.jvdetailscoll.splice(index, 1)
            if (this.jvdetailscoll.length === 0) {
              this.fnSetFirstRowItem()
            }
            this.fnCalcsTotal()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnChangeAccount(index) {

    for (let abo of this.accountColl) {

      if (this.jvdetailscoll[index].accountid === abo.accountid) {
        this.jvdetailscoll[index].accountname = abo.accountname;
      }
    }

    this.jvdetailscoll[index].subledgerid = null

    this.fngetSubledger(this.jvdetailscoll[index])

  }

  fnChangePtype(index) {

    if (this.jvdetailscoll[index].ptype === 'Supplier') {
      this.fnGetSupplier()
      this.jvdetailscoll[index].accountid = null;
    }
    else if (this.jvdetailscoll[index].ptype === 'Customer') {
      this.fnGetCustomer()
      this.jvdetailscoll[index].accountid = null;
    }
    else {
      this.jvdetailscoll[index].partyid = null;
    }

  }

  fnChangeParty(index) {

    this.jvdetailscoll[index].partyname = ""

    for (let abo of this.partyallColl) {

      if (this.jvdetailscoll[index].partyid === abo.partyid) {
        this.jvdetailscoll[index].partyname = abo.partyname;
      }
    }


  }


  fnFocusChangeGridRow(index) {
    this.gridfocusrow = index

  }

  fnFocusSubLedgerRow(index) {

    this.fngetSubledger(this.jvdetailscoll[index])

  }


  fnFocusPartyRow(index) {

    this.fnChangePtype(index)

  }

  fnSetNextFocus(index) {

    if (this.jvdetailscoll.length > 0) {

      if (this.jvdetailscoll.length > index + 1) {
        this.gridfocusrow = index + 1
      }
    }


  }

  //AddAccount
  private fnAddAccount(index) {

    const modalRef = this.productFindService.open(AddaccountComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetAccount();

      if (receivedEntry > 0) {
        this.jvdetailscoll.accountid = receivedEntry

        this.fnReLoadAccount(index);
      }
    });

  }


  fnGetParty() {

    var data = {
      'partyid': 0,
      'ptype': '',
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getParty(data)
      .subscribe(
        (res) => {
          this.partyallColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnGetCustomer() {
    this.partyColl = []
    for (let abo of this.partyallColl) {
      if (abo.ptype === 'C') {
        this.partyColl.push(abo)
      }
    }

  }

  fnGetSupplier() {
    this.partyColl = []
    for (let abo of this.partyallColl) {
      if (abo.ptype === 'S') {
        this.partyColl.push(abo)
      }
    }
  }


  fnGetAccount() {
    this.isLoadingResult = true;

    var data = {
      'accountid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId()
    }
    this.appService.getAccount(data)
      .subscribe(
        (res) => {
          this.accountColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnReLoadAccount(index) {
    var data = {
      'accountid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId()

    }
    this.appService.getAccount(data)
      .subscribe(
        (res) => {
          this.accountColl = res.json().result;

          this.fnChangeAccount(index)
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnPostingConfirm(type) {
    this.confirmationDialogService.confirm('Confirm..', 'Do you  want to ' + type + ' Voucher?')
      .then((confirmed) => {
        if (confirmed) {
          if (type === 'Post') {
            this.fnPosting()
          }
          else if (type === 'UnPost') {
            this.fnUnPosting()
          }

        }
      }
      );
  }


  fnPosting() {
    var data = {
      trxid: this.jvid,
      doctype: 'JOURNALVOUCHER',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertPostings(data)
      .subscribe(
        (res) => {
         
          if (res.json().status === 200) {
        
            this.fnEditFormEdit(this.jvid);
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnUnPosting() {
    var data = {
      trxid: this.jvid,
      doctype: 'JOURNALVOUCHER',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertUnPostings(data)
      .subscribe(
        (res) => {
          
          if (res.json().status === 200) {
          
            var result=res.json().result;
           
            if(result.length>0){
         
              if(result[0].checkresult==='DONE'){
                this.fnEditFormEdit(this.jvid);
              }
              else{
                this.toastr.error('Error', result[0].checkresultmsg);
              }
            }
           
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  
  fnEnableEditBtn() {
    if(this.jvBO.iscancelled===1){
      return false;
    }
    else if (this.jvBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }

  fnEnablePostBtn() {
    if(this.jvBO.iscancelled===1){
      return false;
    }
    else  if (this.jvBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }


  
  fnEnableUnPostBtn() {
    if (this.jvBO.isposted === 1) {
      return true;
    }
    else {
      return false;
    }
    
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  // fnAddjvDetails() {

  //   const modalRef = this.productFindService.open(AddjournalvoucherdetailComponent, { size: <any>'xl' });
  //   modalRef.componentInstance.jvdetailsBO = this.fnSetFirstRowItem()
  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  //     if (receivedEntry.checkstatus === "DONE") {
  //       this.fnSetFirstRowItem()
  //       this.jvdetailscoll[this.jvdetailscoll.length - 1] = receivedEntry.data;
  //       this.fnCalcsTotal()
  //     }

  //   });
  // }


  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }




  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
